(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer-r2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header-r2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lymphelle-native-product"] && !Shopify.designMode) return;
  try {
    
  const lymphelleLocalizationForm = document.getElementById('LymphelleGbLocalization');
  if (lymphelleLocalizationForm && !sessionStorage.getItem('lymphelle-gb-localized')) {
    sessionStorage.setItem('lymphelle-gb-localized', 'true');
    lymphelleLocalizationForm.submit();
  }
  document.querySelectorAll('.lymphelle-native').forEach((root) => {
    const mainImage = root.querySelector('[data-lym-main-image]');
    const mainMobileSource = root.querySelector('[data-lym-main-mobile-source]');
    root.querySelectorAll('[data-lym-mobile-image]').forEach((button) => button.addEventListener('click', () => {
      if (mainImage) mainImage.src = button.dataset.lymDesktopImage || button.dataset.lymMobileImage;
      if (mainMobileSource) mainMobileSource.srcset = button.dataset.lymMobileImage || '';
      root.querySelectorAll('.lym-thumb').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    }));
    let activePlan = 'subscribe';
    let activeBundle = root.querySelector('[data-lym-bundle].is-selected') || root.querySelector('[data-lym-bundle]');
    const variantInput = root.querySelector('[data-lym-selected-variant]');
    const addButton = root.querySelector('[data-lym-add]');
    const selectionLabel = root.querySelector('[data-lym-selection-label]');
    const selectionMonthly = root.querySelector('[data-lym-selection-monthly]');
    const applySelection = () => {
      root.querySelectorAll('[data-lym-bundle]').forEach((bundle) => {
        const price = activePlan === 'subscribe' ? bundle.dataset.subscribeMonthly : bundle.dataset.oneTimeMonthly;
        const priceNode = bundle.querySelector('[data-lym-bundle-price]');
        if (priceNode) priceNode.textContent = price || '';
      });
      if (!activeBundle) return;
      const id = activePlan === 'subscribe' ? activeBundle.dataset.subscribeId : activeBundle.dataset.oneTimeId;
      const price = activePlan === 'subscribe' ? activeBundle.dataset.subscribePrice : activeBundle.dataset.oneTimePrice;
      const monthly = activePlan === 'subscribe' ? activeBundle.dataset.subscribeMonthly : activeBundle.dataset.oneTimeMonthly;
      const available = activePlan === 'subscribe' ? activeBundle.dataset.subscribeAvailable : activeBundle.dataset.oneTimeAvailable;
      if (variantInput) {
        variantInput.value = id || '';
        variantInput.setAttribute('value', id || '');
      }
      if (selectionLabel) selectionLabel.textContent = activeBundle.dataset.label || '';
      if (selectionMonthly) selectionMonthly.textContent = `${monthly || ''}/month`;
      root.querySelectorAll('[data-lym-button-price],[data-lym-sticky-price]').forEach((node) => { node.textContent = price || ''; });
      if (addButton) addButton.disabled = available !== 'true';
    };
    root.querySelectorAll('[data-lym-plan]').forEach((button) => button.addEventListener('click', () => {
      activePlan = button.dataset.lymPlan || 'one_time';
      root.querySelectorAll('[data-lym-plan]').forEach((plan) => {
        const selected = plan === button;
        plan.classList.toggle('is-selected', selected);
        plan.setAttribute('aria-pressed', String(selected));
      });
      applySelection();
    }));
    root.querySelectorAll('[data-lym-bundle]').forEach((button) => button.addEventListener('click', () => {
      activeBundle = button;
      root.querySelectorAll('[data-lym-bundle]').forEach((bundle) => bundle.classList.toggle('is-selected', bundle === button));
      applySelection();
    }));
    applySelection();
    const menuButton = root.querySelector('[data-lym-menu-button]');
    const menu = root.querySelector('[data-lym-menu]');
    menuButton?.addEventListener('click', () => {
      const open = menu?.hasAttribute('hidden');
      if (open) menu?.removeAttribute('hidden'); else menu?.setAttribute('hidden', '');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.setAttribute('hidden', ''); menuButton?.setAttribute('aria-expanded', 'false'); }));
    root.querySelector('[data-lym-scroll-offer]')?.addEventListener('click', () => root.querySelector('#offer')?.scrollIntoView({behavior:'smooth',block:'center'}));
    const sticky = root.querySelector('[data-lym-sticky]');
    const onScroll = () => sticky?.classList.toggle('is-visible', window.scrollY > 700);
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

    const drawer = root.querySelector('[data-lym-cart-drawer]');
    const overlay = root.querySelector('[data-lym-cart-overlay]');
    const itemsNode = root.querySelector('[data-lym-cart-items]');
    const summaryNode = root.querySelector('[data-lym-cart-summary]');
    const totalNode = root.querySelector('[data-lym-cart-total]');
    const footNode = root.querySelector('[data-lym-cart-foot]');
    const closeButton = root.querySelector('[data-lym-cart-close]');
    const errorNode = root.querySelector('[data-lym-cart-error]');
    const routesRoot = window.Shopify?.routes?.root || '/';
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency}).format(amount / 100);
    const setCount = (count) => root.querySelectorAll('[data-lym-cart-count]').forEach((node) => { node.textContent = String(count); });
    const openDrawer = () => {
      if (!drawer || !overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeButton?.focus();
    };
    const closeDrawer = () => {
      if (!drawer || !overlay) return;
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      window.setTimeout(() => { overlay.hidden = true; }, 280);
    };
    const renderCart = (cart) => {
      if (!itemsNode || !summaryNode || !totalNode || !footNode) return;
      setCount(cart.item_count || 0);
      summaryNode.textContent = cart.item_count ? `${cart.item_count} item${cart.item_count === 1 ? '' : 's'} in your cart` : 'Your cart is empty';
      itemsNode.replaceChildren();
      footNode.hidden = !cart.item_count;
      if (!cart.item_count) {
        const empty = document.createElement('div');
        empty.className = 'lym-cart-empty';
        const title = document.createElement('strong');
        title.textContent = 'Your cart is empty';
        const copy = document.createElement('span');
        copy.textContent = 'Add Lymphelle to get started.';
        empty.append(title, copy);
        itemsNode.append(empty);
        return;
      }
      totalNode.textContent = money(cart.total_price, cart.currency);
      cart.items.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'lym-cart-item';
        const image = document.createElement('img');
        image.src = item.image || '';
        image.alt = '';
        image.width = 74;
        image.height = 74;
        const copy = document.createElement('div');
        copy.className = 'lym-cart-item-copy';
        const title = document.createElement('strong');
        title.textContent = item.product_title;
        const variant = document.createElement('small');
        variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
        const quantity = document.createElement('div');
        quantity.className = 'lym-cart-qty';
        const minus = document.createElement('button');
        minus.type = 'button';
        minus.textContent = '−';
        minus.setAttribute('aria-label', 'Decrease quantity');
        minus.addEventListener('click', () => changeLine(item.key, Math.max(0, item.quantity - 1)));
        const value = document.createElement('span');
        value.textContent = String(item.quantity);
        const plus = document.createElement('button');
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Increase quantity');
        plus.addEventListener('click', () => changeLine(item.key, item.quantity + 1));
        quantity.append(minus, value, plus);
        copy.append(title, variant, quantity);
        const side = document.createElement('div');
        side.className = 'lym-cart-item-price';
        const price = document.createElement('span');
        price.textContent = money(item.final_line_price, cart.currency);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'lym-cart-remove';
        remove.textContent = 'Remove';
        remove.addEventListener('click', () => changeLine(item.key, 0));
        side.append(price, remove);
        row.append(image, copy, side);
        itemsNode.append(row);
      });
    };
    const changeLine = async (key, quantity) => {
      if (!drawer) return;
      drawer.classList.add('is-loading');
      try {
        const response = await fetch(routesRoot + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key, quantity})});
        if (!response.ok) throw new Error('Cart update failed');
        renderCart(await response.json());
      } finally {
        drawer.classList.remove('is-loading');
      }
    };
    const loadCart = async () => {
      const response = await fetch(routesRoot + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Cart load failed');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };
    root.querySelectorAll('[data-lym-cart-open]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
      loadCart().catch(() => {});
    }));
    closeButton?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer(); });
    root.querySelector('.lym-product-form')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const selectedId = activePlan === 'subscribe' ? activeBundle?.dataset.subscribeId : activeBundle?.dataset.oneTimeId;
      if (!selectedId || !addButton) return;
      const label = addButton.querySelector('span');
      const originalLabel = label?.textContent || 'Add to Cart';
      addButton.disabled = true;
      if (label) label.textContent = 'Adding…';
      if (errorNode) errorNode.hidden = true;
      try {
        const response = await fetch(routesRoot + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:Number(selectedId), quantity:1}]})});
        if (!response.ok) throw new Error('Add to cart failed');
        await loadCart();
        openDrawer();
      } catch (error) {
        if (errorNode) {
          errorNode.textContent = "We couldn't add that to your cart. Please try again.";
          errorNode.hidden = false;
        }
      } finally {
        addButton.disabled = false;
        if (label) label.textContent = originalLabel;
      }
    });
    loadCart().catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
